export default "__VITE_ASSET__pW6UiDIr__"